import styled from "styled-components";
import { ModalSlider } from "@gcs/design-system/react";

import {
  DefaultTitleMediumFactory,
  DefaultParagraphMediumFactory,
} from "../Typograph/Typograph.Style";

export const ModalResponsive = styled(ModalSlider)(({ theme }) => ({
  padding: "40px 20px 16px",

  [theme.breakpoint.lg()]: {
    maxWidth: "556px",
    padding: "56px 112px 56px 60px",
    borderTopLeftRadius: "16px",
    borderBottomLeftRadius: "16px",
  },

  div: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",

    textAlign: "left",
    maxWidth: "100%",
    margin: "0",
    padding: "0px !important",
  },

  "> button:first-of-type": {
    borderRadius: "8px",
    width: "50px",
    height: "50px",

    svg: {
      fontSize: "50px",
      color: "white",
    },
  },
}));

export const ModalResponsiveHeader = styled.header(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
}));

export const ModalResponsiveSpan = styled.span(({ theme }) => ({
  letterSpacing: "3px",
  fontSize: "12px",
  color: theme.color.neutral["03"],
  textTransform: "uppercase",
  fontWeight: "700",
}));

export const ModalResponsiveTitle = styled.h1(({ theme }) => ({
  ...DefaultTitleMediumFactory({ theme }),
  color: theme.color.neutral["02"],
  margin: 0,
  padding: 0,
}));

export const ModalResponsiveBody = styled.div(({ theme }) => ({
  flex: 1,
  maxHeight: "50vh",
  overflowY: "auto",

  [theme.breakpoint.lg()]: {
    maxHeight: "60vh",
  },

  p: {
    ...DefaultParagraphMediumFactory({ theme }),
    fontWeight: "400",
    color: theme.color.neutral["02"],
    margin: 0,
    padding: 0,
  },
}));

export const ModalResponsiveFooter = styled.footer(({ theme }) => ({
  paddingTop: "2px",
  borderTop: `1px solid ${theme.color.line.medium}`,
  width: "100%",

  [theme.breakpoint.lg()]: {},

  button: {
    width: "100%",
    borderRadius: "8px",
  },
}));
